import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useTrackFont} from '../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../services/env/siteSettings/fonts/fonts';
import {backButtonAction} from '../../store/actions';
import {emailSelector} from '../../store/selectors';
import styles from './EmailEdit.scss';
import {IInner} from './EmailEdit.types';

export const EmailEdit: React.FunctionComponent<IInner> = () => {
  const {t} = useTranslation();
  const email = useSelector(emailSelector);
  const trackFont = useTrackFont();
  const buttonStyle = withoutSize(trackFont);
  const dispatch = useDispatch();

  return (
    <div className={styles.emailEdit} style={buttonStyle}>
      <div className={styles.emailLabel}>{t('mgw.emailTo', {email})}</div>
      <div>
        <button className={styles.editEmailButton} onClick={() => dispatch(backButtonAction())}>
          {t('mgw.editEmailLabel')}
        </button>
      </div>
    </div>
  );
};

EmailEdit.displayName = 'EmailEdit';
